import Tile from '../subcomponents/Tile';
import './styles/nextLetters.css';
import { useEffect, useState } from 'react';
import { getBonusLetter, getNextLetters } from '../utils/nextLetterHelper';
import { useGameStore } from '../../store/gameStore';
import { useShallow } from 'zustand/react/shallow';

function NextLetters() {
  const bonusLetter = getBonusLetter();

  // Subscribe to game store
  const { mode, moveCount } = useGameStore(
    useShallow((state) => ({
      mode: state.mode,
      moveCount: state.gameData[state.mode].moveCount,
    }))
  );

  const isBonusLetter = (letter: string) => {
    return letter === bonusLetter;
  };

  const [nextLetters, setNextLetters] = useState<string[]>(getNextLetters(mode, moveCount));

  useEffect(() => {
    setNextLetters(getNextLetters(mode, moveCount));
  }, [moveCount]);

  return (
    <div className="next-letters-container">
      <div className="next-letters-wrapper">
        <span className="next-letters-text">Next:</span>
        <span className="next-letters">
          {nextLetters.map((letter, idx) => (
            <Tile
              key={idx}
              value={letter}
              medium={idx === 0}
              small={idx > 0}
              bonus={isBonusLetter(letter)}
            />
          ))}
        </span>
      </div>
    </div>
  );
}

export default NextLetters;
